function throttle(func, wait) {
    let timeout;

    return function startTimeout(...args) {
        if (!timeout) {
            timeout = setTimeout(() => {
                func.apply(this, args);
                timeout = null;
            }, wait);
        }
    };
}

export { throttle };
